import {
  Box,
  BoxContent,
  Columns,
  ColumnsItem,
  Icon,
  Link,
  RowItem,
  Rows,
  Text,
  Title,
  TitleLevels,
} from '@bytel/trilogy-react-ts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as routerLink } from 'react-router-dom';
import { BtnNavigationProps } from '../button-navigation/type';
import './style.css';

const BoxContentNavigation: React.FC<BtnNavigationProps> = ({ routeRef, dataCy, titre, count, iconName }) => {
  const { t } = useTranslation('domain/home', {
    keyPrefix: 'navButtons',
  });

  return (
    <Box className="is-fullwidth is-fullheight" data-cy={`box-${dataCy}`}>
      <BoxContent className={`is-${iconName}`}>
        <Rows className="is-flex">
          <RowItem>
            <Columns className="is-flex is-aligned-center">
              <ColumnsItem size={8}>
                <Title className="is-unselectable" level={TitleLevels.THREE} data-cy={`title-${dataCy}`}>
                  {titre}
                </Title>
              </ColumnsItem>
              <ColumnsItem size={4} className="is-flex is-vertical is-aligned-right">
                <Link
                  to={routeRef?.href}
                  routerLink={routerLink}
                  data-cy={`link-${dataCy}`}
                  className="is-plain is-justified-center is-paddingless"
                >
                  <Columns marginSize={2}>
                    <ColumnsItem>
                      <Text data-cy={`icon-${dataCy}`}>{t('modifier')}</Text>
                    </ColumnsItem>
                    <ColumnsItem>
                      <Icon name="tri-pencil" data-cy={`icon-${dataCy}`} />
                    </ColumnsItem>
                  </Columns>
                </Link>
              </ColumnsItem>
            </Columns>
          </RowItem>
          <RowItem>
            <Title className="is-unselectable boxNavigationCount" data-cy={`description-${dataCy}`}>
              {count}
            </Title>
          </RowItem>
        </Rows>
      </BoxContent>
    </Box>
  );
};

export default BoxContentNavigation;
